import { createAction } from 'Utility/Redux';

enum Types {
    HANDLE_TURNIP_CLICK =  'handleTurnipClick',
    HANDLE_CLAIM_CLICK =  'handleClaimClick',
}

export const LuckyTurnipsActions = {
    handleTurnipClick: createAction(
        Types.HANDLE_TURNIP_CLICK,
        resolve => (index: number) => resolve<number>(index),
    ),
    handleClaimClick: createAction(
        Types.HANDLE_CLAIM_CLICK,
        resolve => () => resolve(),
    )
};
